import React from 'react';
import { Check } from 'lucide-react';

const LABELS = ['Entity Confirmed', 'Select Classes', 'Risk Details', 'Review & Submit'];

export default function SubmissionSteps({ done = [], current = 0 }) {
  return (
    <div className="flex items-center flex-wrap gap-y-2" data-testid="submission-steps">
      {LABELS.map((label, i) => {
        const isDone = !!done[i];
        const isCurrent = !isDone && i === current;
        return (
          <React.Fragment key={label}>
            {i > 0 && <div className="h-px w-5 md:w-9 mx-1.5" style={{ background: isDone || isCurrent ? '#1A4C7C' : 'rgba(136,150,168,0.3)' }} />}
            <div className="flex items-center gap-1.5" data-testid={`submission-step-${i + 1}`}>
              <span className="w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-bold shrink-0"
                style={{
                  background: isDone ? '#1D9E75' : isCurrent ? '#1A4C7C' : 'rgba(136,150,168,0.15)',
                  color: isDone || isCurrent ? '#FFFFFF' : '#64748B',
                }}>
                {isDone ? <Check className="w-3 h-3" /> : i + 1}
              </span>
              <span className="text-[11px] font-medium whitespace-nowrap" style={{ color: isDone ? '#1D9E75' : isCurrent ? '#0D1B2A' : '#64748B' }}>{label}</span>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
}
